

require('./dataCaptureListPicker');
require('./dataCaptureList');

const angular = window.angular;

//Model name
angular.module('dash.topControls.dataCaptureSelector', [
  'dash.topControls.dataCaptureSelector.dataCaptureListPicker',
  'dash.topControls.dataCaptureSelector.dataCaptureList'
])

  //Angular stuff
  .controller('DataCaptureSelectorController', require('./DataCaptureSelectorController'))
  .directive('datacaptureSelector', require('./DataCaptureSelectorDirective'))

  //Flux Actions and Store
  .factory('DataCaptureSelectorActions', require('./DataCaptureSelectorActions'))
  .factory('DataCaptureSelectorStore', require('./DataCaptureSelectorStore'))

  //Bind store to actions through init method
  .run(['DataCaptureSelectorStore', function (DataCaptureSelectorStore) {

    DataCaptureSelectorStore.init();
  }]);



// WEBPACK FOOTER //
// ./src/app/dash/topControls/dataCaptureSelector/index.js